import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";

import Ballina from "./pages/Ballina";
import { Kurset } from "./pages/Kurset";
import { Stafi } from "./pages/Stafi";
import {RrethNesh}from "./pages/RrethNesh";
import { Kontakt } from "./pages/Kontakt";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Ballina />} />
        <Route path="/kurset" element={<Kurset/>} />
        <Route path="/stafi" element={<Stafi />} />
        <Route path="/rreth-nesh" element={<RrethNesh/>} />
        <Route path="/kontakt" element={<Kontakt />} />
      </Routes>
    </Router>
  );
}

export default App;
